<qpoint-map #qpointMap [fitToBoundsDelay]="100"
    [showZoomButtons]="false"
    [showFitBoundsButton]="true"
    [enableFullscreenControl]="false"
    [zoomPosition]="zoomPosition"
    [mapTypePosition]="mapTypePosition"
    [activeMapType]="'hybrid'"
    [activeFitBounds]="'overview'"
    [stickToCenter]="true"
    [center]="center"
    [gestureHandling]="'greedy'"
    [setZoomLevelOnFitBounds]="false"
    [fitToBoundsOnMarkerChanges]="false"
    [zoom]="15"

    (mapLoaded)="onMapLoaded($event)"
    (mapTypeChanged)="onMapTypeChanged($event)"
    (fitBoundsChanged)="onFitBoundsChanged($event)">

    <qpoint-map-marker *ngIf="siteMarkerOptions" [options]="siteMarkerOptions"></qpoint-map-marker>
    <qpoint-map-marker *ngIf="plantMarkerOptions" [options]="plantMarkerOptions"></qpoint-map-marker>
    <qpoint-map-marker *ngIf="currentTruckMarkerOptions" [options]="currentTruckMarkerOptions"></qpoint-map-marker>
    <qpoint-map-polyline [polyline]="routeData"
        [options]="{ strokeColor: '#219ebc99', editable: false }"></qpoint-map-polyline>
    <qpoint-map-polygon [polygon]="plantFence"></qpoint-map-polygon>
    <qpoint-map-polygon [polygon]="siteFence"></qpoint-map-polygon>
</qpoint-map>